import * as React$1 from "react";

//#region src/components/icon/static/generic-pharmacy.svg
var _path, _path2, _path3, _path4;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgGenericPharmacy = function SvgGenericPharmacy$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "m4.244 4.15-.898 3.7h17.307l-.906-3.7zm-2.1-1.1c.196-.754.89-1.2 1.576-1.2h16.55c.66 0 1.401.419 1.583 1.23l1.25 5.102c.29 1.139-.684 1.968-1.579 1.968H2.476c-.923 0-1.864-.845-1.578-1.967L2.142 3.06z",
		clipRule: "evenodd"
	})), _path2 || (_path2 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M4.15 10.15v9.7h15.7v-9.7zm-2.3-.544c0-1.011.84-1.756 1.78-1.756h16.74c.94 0 1.78.745 1.78 1.756v10.788c0 1.012-.84 1.756-1.78 1.756H3.63c-.94 0-1.78-.744-1.78-1.756z",
		clipRule: "evenodd"
	})), _path3 || (_path3 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M12 10.85c.635 0 1.15.515 1.15 1.15v6a1.15 1.15 0 0 1-2.3 0v-6c0-.635.515-1.15 1.15-1.15",
		clipRule: "evenodd"
	})), _path4 || (_path4 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M16.15 15A1.15 1.15 0 0 1 15 16.15H9a1.15 1.15 0 0 1 0-2.3h6c.635 0 1.15.515 1.15 1.15",
		clipRule: "evenodd"
	})));
};
var generic_pharmacy_default = SvgGenericPharmacy;

//#endregion
export { generic_pharmacy_default as default };